import { useCallback, useMemo } from 'react'

import { useAppDispatch } from '@app/utils/redux'

import { useTrackableValue } from '@app/packages/reactives/useTrackableValue'

import { getPushNotificationsManager } from '@app/store/actions/contexts/pushNotificationsManager'

export const usePushNotifications = () => {
  const dispatch = useAppDispatch()
  const manager = dispatch(getPushNotificationsManager())
  const pending = useTrackableValue(manager.pending)
  const subscribed = useTrackableValue(manager.subscribed)
  const supported = useTrackableValue(manager.supported)
  const blocked = useTrackableValue(manager.blocked)
  const token = useTrackableValue(manager.token)

  const subscribe = useCallback(() => {
    return manager.subscribe()
  }, [manager])

  const unsubscribe = useCallback(() => {
    return manager.unsubscribe()
  }, [manager])

  return useMemo(
    () => ({
      pending,
      supported,
      subscribed,
      blocked,
      subscribe,
      unsubscribe,
      token,
    }),
    [blocked, pending, subscribe, subscribed, supported, token, unsubscribe]
  )
}
